import React from 'react';
import PropTypes from 'prop-types';

import TagIconOutline from '../../../../components/icons/TagIconOutline';

const propTypes = {
  label: PropTypes.string,
};

const CheckoutCartDiscountApplied = ({ label }) => {
  if (!label) {
    return null;
  }

  return (
    <div className="checkout-cart-discount-applied">
      <TagIconOutline
        className="checkout-cart-discount-applied-icon"
        color="currentColor"
      />
      {label} applied
    </div>
  );
};

CheckoutCartDiscountApplied.propTypes = propTypes;

export default CheckoutCartDiscountApplied;
